"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

function restoreScrollLock() {
  const html = document.documentElement;
  const body = document.body;
  html.style.overflow = "";
  (html.style as any).overscrollBehaviorY = "";
  body.style.overflow = "";
  (body.style as any).overscrollBehaviorY = "";
  body.style.height = "";
}

export default function ScrollRestoreOnRouteChange() {
  const pathname = usePathname();
  const isFeedPage = pathname === "/feed" || pathname?.startsWith("/feed/");

  useEffect(() => {
    if (!isFeedPage) {
      restoreScrollLock();
    }
  }, [pathname, isFeedPage]);

  return null;
}
